export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_5.2-2b01930e2d75395fd69a64617d63fb60.svg";